import React, {useState, useEffect} from 'react';
import "../../../css/pages/press.scss";
import pressImage from "../../../images/press/pressImage.png";

function Press() {
    return (
        <div className='press-container'>
           <p className='title-text'>Press</p>
           <div className='content-class'>
                <img className='press-image' src={pressImage} />
                <p className='check-back'>
                    <span>For Press Enquiries, please email </span>
                    <a className='email-text' href = "mailto:norm.shaw@rs11.com">norm.shaw@rs11.com.</a>
                </p>
           </div>
        </div>
    )
}

export default Press;